<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label">Подразделение</div>
            <div :class="fieldValueClass">
                <ai-select-box-clearable
                    v-model:value="value"
                    :data-source="dataSource"
                    :disabled="disabled"
                    :showClearButton="false"
                    display-expr="podr_name"
                    value-expr="podr"
                    @opened="onOpenHandler"
                    @valueChanged="valueChanged"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, inject, onBeforeMount, ref } from 'vue';
import AiSelectBoxClearable from '@/components/ai-select-box-clearable.vue';
import { getPodr } from '@/service/contract-service';
import { useRoute } from 'vue-router';

const route = useRoute();

const props = defineProps({
    ds: {
        type: Array,
        default: () => [],
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    callbacks: {
        type: Object,
        default: () => ({
            userDataChanged: null,
            getDictionary: null,
        }),
    },
    meta: {
        type: Object,
        default: () => {},
    },
});

const serverData = inject('serverData');
const userData = inject('userData');
const dataSource = ref(props.ds);

const onOpenHandler = async () => {
    await getDictionaryHandler();
};

onBeforeMount(async () => {
    const initialDS = [
        {
            [`podr`]: userData?.value[`podr`],
            [`podr_name`]: userData?.value[`podr_name`],
        },
    ];
    if (dataSource.value.length === 0 && serverData?.value.length !== 0 && initialDS) {
        dataSource.value = initialDS;
    }
});

const getDictionaryHandler = async () => {
    const response = await getPodr(route.params.dep); //await getDictionary(props.meta.extParams.dictionaryRoutePath);

    if (response) {
        dataSource.value = response;
    } else {
        console.log(response.error, response.uuid);
    }
};

const valueChanged = e => {
    userDataChange(e.value, e.text);
};

const userDataChange = (value, text) => {
    userData.value['podr'] = value;
    if (text) {
        userData.value['podr_name'] = text;
    }
    props.callbacks.userDataChanged();
};

const isModified = computed(() => {
    return userData?.value['podr'] !== serverData?.value['podr'];
});

const value = computed(() => {
    if (userData.value['podr'] === undefined) {
        return null;
    }
    return userData.value['podr'];
});

const fieldValueClass = computed(() => {
    return {
        'dx-field-value': true,
        'ai-field-modified': isModified.value,
    };
});
</script>
